import React, { useRef, useState } from 'react'

import s from './styles.module.scss'

import { useOnClickOutside } from '../../../../lib/hooks'

interface IHouseSearchResultsFiltersSelectorProps {
  label: React.ReactNode
  onSelect: (value: string) => void
  options: {
    label: string
    value: string
  }[]
}

export const HouseSearchResultsFiltersSelector = ({
  label,
  onSelect,
  options,
}: IHouseSearchResultsFiltersSelectorProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const listRef = useRef<HTMLDivElement | null>(null)

  useOnClickOutside(listRef, () => setIsOpen(false))

  return (
    <div ref={listRef} className={s.container}>
      <div className={s.buttonContainer} onClick={() => setIsOpen(!isOpen)}>
        <div>{label}</div>
      </div>
      {isOpen && (
        <div className={s.listContainer}>
          {options.map((options) => (
            <div
              key={options.value}
              onClick={() => {
                setIsOpen(false)
                onSelect(options.value)
              }}
            >
              <div className={s.optionLabel}>{options.label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
